import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-user-modal',
  templateUrl: './update-user-email.component.html',
  styleUrls: ['./update-user-email.component.scss']
})
export class UpdateUserEmailComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<UpdateUserEmailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }



  public email:string = "";
  public confirmEmail: string = "";
  public password: string = "";
  ngOnInit() {
  }




  validate() {



   // console.log()
    if (this.email == this.confirmEmail) {
      this.data = {email: this.email, password: this.password}

      this.dialogRef.close(this.data);




    }
  }

}
